export default "__VITE_PUBLIC_ASSET__f7faf1ce__"